import type { LocationAutocompleteParams } from '@/api/types/autocomplete'

import type { PlaceDetails, OptionType } from './types'

export const getAddress = (res: any) => {
  if (!res) return null

  const parts = res?.address_components?.reduce(
    (acc, component) => {
      if (component.types.includes('route')) {
        acc.route = component.short_name
      }

      if (component.types.includes('street_number')) {
        acc.streetNumber = component.short_name
      }

      return acc
    },
    {
      route: null,
      streetNumber: null,
    }
  )

  return `${parts.route || ''} ${parts.streetNumber || ''}`
}

export const getPostalCode = (place: any) => {
  const postalCode = place.address_components.find((component) =>
    component.types.includes('postal_code')
  )
  return postalCode ? postalCode.long_name : null
}

export const getGeocodeDataByPlaceId = async (
  getGeocode: any,
  address: string
): Promise<PlaceDetails | undefined> => {
  const response = await getGeocode({ address })
  const place = response?.data?.results?.[0]

  if (place) {
    return {
      address: getAddress(place),
      postalCode: getPostalCode(place),
      lat: place.geometry.location.lat,
      lon: place.geometry.location.lng,
    }
  }
}

export const getPlacePredictions = async (
  getLocationAutocomplete: any,
  query: LocationAutocompleteParams
): Promise<OptionType[] | undefined> => {
  const response = await getLocationAutocomplete(query)

  if (response?.data?.predictions?.length) {
    return response.data.predictions.map((prediction) => ({
      label: prediction?.description,
      value: prediction?.description,
      description: prediction?.description,
      place_id: prediction?.place_id,
    }))
  }
}

export const getSelectedOption = (
  description: string | string[],
  options: OptionType[]
): OptionType | undefined => {
  if (typeof description === 'string') {
    return options?.find((option) => option.description === description)
  }
}
